'use client'

import RightNavbarSliderMenu from './RightNavbarSliderMenu'
import { isHostDomainClient } from 'app/utils/domainClient'
import { useSession } from 'components/providers/SessionProvider'
import { GOD } from 'api/admins'

interface RightNavbarProps {
    user?: IUser | null
    hasAdminRole?: boolean
}

const RightNavbar = ({ user: userProp, hasAdminRole: hasAdminRoleProp }: RightNavbarProps = {}) => {
    const { user: sessionUser, hasAdminRole: sessionHasAdminRole } = useSession()
    const isHost = isHostDomainClient()
    // Use prop user if provided, otherwise fall back to session user
    const user = userProp ?? sessionUser ?? null
    // Session hasAdminRole from layout; fallback to GOD so admin link always shows for GOD
    const hasAdminRole = hasAdminRoleProp ?? sessionHasAdminRole ?? (user?.role === GOD)

    return <RightNavbarSliderMenu user={user} isHostDomain={isHost} hasAdminRole={hasAdminRole} />
}

export default RightNavbar
